import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import {
  type GridAutoGeneratedGroupNode,
  type GridDataGroupNode,
  type GridRenderCellParams,
  useGridApiContext,
} from "@mui/x-data-grid-premium";
import type { AgingDetailGridRow } from "./AgingDetailTable.types";

interface Props {
  rowNode: GridDataGroupNode | GridAutoGeneratedGroupNode;
  params: GridRenderCellParams<AgingDetailGridRow>;
}
const GroupingCell = ({ rowNode, params }: Props) => {
  const apiRef = useGridApiContext();
  const isExpanded = rowNode.childrenExpanded === true;
  const count = rowNode.children?.length ?? 0;
  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
      <IconButton
        size="small"
        onClick={() => apiRef.current?.setRowChildrenExpansion(params.id, !isExpanded)}
        sx={{ p: 0 }}
      >
        {isExpanded ? <ArrowDropDownRoundedIcon fontSize="small" /> : <ArrowRightRoundedIcon fontSize="small" />}
      </IconButton>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {rowNode.groupingKey?.toString()} ({count})
      </Typography>
    </Stack>
  );
};

export default GroupingCell;
